import { CollectionScope, collectionScope } from '@nemuru-eng/js-api-client';

import { useCollectionScope } from '@/hooks/useCollectionScope';
import { useUser } from '@/hooks/useUser';

export const useMetricsScope = (pageScope?: CollectionScope): CollectionScope | undefined => {
  const { isUserAdmin } = useUser();
  const ownScope = useCollectionScope();
  return isUserAdmin ? pageScope ?? collectionScope.all() : ownScope;
};
